module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/main-1bf222bc677ca25d650263a836186a68.svg";